import Dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
import dayjs from 'dayjs';
Dayjs.extend(AdvancedFormat);
export type TDayjs = dayjs.Dayjs;
export function getDateByTimestamp(timestamp: number) {
  return dayjs.unix(timestamp).format('YYYY-MM-DD');
}
export function getTimeByTimestamp(timestamp: number) {
  return dayjs.unix(timestamp).format('HH:mm:ss');
}
export function getNowTimestamp() {
  return dayjs().unix();
}
export function getBrowserTimeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {
    return 'Etc/UTC';
  }
}

export function getRelativeTime(timestamp: number | string): string {
  const now = dayjs();
  const target =
    typeof timestamp === 'string'
      ? dayjs.unix(parseInt(timestamp))
      : dayjs.unix(timestamp);
  const diff = target.diff(now, 'second');
  const absDiff = Math.abs(diff);

  if (absDiff >= 86400) {
    // 大于等于1天
    return `${Math.floor(absDiff / 86400)}d`;
  }
  if (absDiff >= 3600) {
    // 大于等于1小时
    return `${Math.floor(absDiff / 3600)}h`;
  }
  if (absDiff >= 60) {
    // 大于等于1分钟
    return `${Math.floor(absDiff / 60)}m`;
  }
  return `${absDiff}s`;
}
